import React from 'react';
import { SimpleImg as LazyImage } from 'react-simple-img';
import { formatSecsDuration, getThumbnail } from '../../utils';
import { SLIDER_ITEM_THUMBNAIL } from '../../config/Thumbnail';
import styles from './Item.module.css';

import icMiniPlayCircle from './../../assets/ic-mini-play.svg';

const ItemComponent = ({ item }) => {
  const thumbnail = getThumbnail(item, SLIDER_ITEM_THUMBNAIL);

  return (
    <div className={styles['slider-item']} title={item.titleLocalized}>
      <LazyImage
        src={thumbnail}
        imgStyle={{
          objectFit: 'cover',
        }}
        height={250}
        alt='thumbnail'
        className='lazy-slider-item-img'
      />
      {item.position && (
        <div className={styles['progress-wrapper']}>
          <div className={styles['progress-detail']}>
            <div>
              <img src={icMiniPlayCircle} alt='mini-play-icon' />
            </div>
            <span>
              {formatSecsDuration(item.duration, { format: 'mm ss' })}
            </span>
          </div>
          <div className={styles['progress-bar']}>
            <div
              style={{
                width: item.position.percentage + '%',
                height: '100%',
                backgroundColor: '#F20303',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemComponent;
